export function editorStateIsEmpty(editorState) {
  const parser = new DOMParser();
  const html = parser.parseFromString(editorState, 'text/html');
  return !html.body.innerText;
}
